import { createUseStyles } from 'react-jss'
import themeConfigStyleService from '../../services/theme-config-style-service'

const useStyles = createUseStyles((theme) => ({
  '@global': {
    ...themeConfigStyleService.getStyles({
      theme,
      isRoot: true,
      overrides: [
        {
          key: 'colors.pages.products.backgroundColor',
          styleProperty: '--ui-body-background-color',
        },
      ],
    }),
  },
  containerFluid: {
    width: '100%',
    padding: [[0, '2rem', '9rem']],
    overflow: 'hidden',
  },
  container: {
    textAlign: 'center',
    minHeight: '100rem',
  },
  containerTitle: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: '10px',
  },
  title: {
    margin: '0 0 2rem',
  },
  breadcrumb: {
    paddingTop: '3rem',
    marginBottom: '1.7rem',
  },
  dineInOrderPlacedButtonContainer: {
    height: '6rem',
    [`@media (min-width: ${theme.mediaQueries.desktop}px)`]: {
      height: 'auto',
    },
  },
  dineInOrderPlacedButtonStickyContainer: {
    display: 'block',
    width: '100%',
    boxShadow: '0 0.2rem 1rem rgba(0,0,0,0.1)',
    borderTop: `1px solid ${theme.colors.bgMedium}`,
    borderBottom: `1px solid ${theme.colors.bgMedium}`,
    paddingTop: '0.5rem',
    textAlign: 'center',
    backgroundColor: theme.colors.background,
    position: 'fixed',
    zIndex: 10,
    left: 0,
    [`@media (min-width: ${theme.mediaQueries.desktop}px)`]: {
      position: 'static',
    },
  },
  dineInOrderPlacedTableNumber: {
    fontWeight: 'bold',
    fontSize: '1.6rem',
  },
  dineInOrderPlacedButton: {
    display: 'block',
    width: '100%',
    textTransform: 'none',
    textAlign: 'center',
    fontSize: '1.4rem',
    paddingBottom: '0.5rem',
  },
  orderMethod: {
    apparcence: 'none',
    border: 'none',
    background: 'none',
    padding: '1rem',
    paddingRight: '3.2rem',
    maxWidth: '80vw',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    position: 'relative',
    [`@media (min-width: ${theme.mediaQueries.tablet}px)`]: {
      maxWidth: '45rem',
    },
  },
  orderMethodValue: {
    fontWeight: 600,
  },
  orderMethodIcon: {
    marginLeft: '1rem',
    position: 'absolute',
    top: '50%',
    right: '1rem',
    transform: 'translateY(-50%)',
  },

  containerProducts: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    flexWrap: 'wrap',
    gap: 'var(--pages-products-list-gap)',
    padding: '1.6rem 0',
  },
  productCards: {
    flexBasis: 'var(--pages-products-item-width)',
    ...themeConfigStyleService.getStyles({
      theme,
      overrides: [
        {
          key: 'config.pages.products.item.padding',
          styleProperty: '--ui-product-card-padding',
        },
        {
          key: 'colors.pages.products.item.backgroundColor',
          styleProperty: '--ui-product-card-background-color',
        },
        {
          key: 'config.pages.products.item.roundedCorners',
          styleProperty: '--ui-product-card-border-radius',
        },
        {
          key: 'config.pages.products.item.thumbnail.position',
          styleProperty: '--ui-product-card-flex-direction',
        },
        {
          key: 'config.pages.products.item.thumbnail.position',
          styleProperty: '--ui-product-card-thumbnail-width',
        },
        {
          key: 'config.pages.products.item.thumbnail.position',
          styleProperty: '--ui-product-card-thumbnail-max-width',
        },
        {
          key: 'config.pages.products.item.thumbnail.position',
          styleProperty: '--ui-product-card-content-padding',
        },
        {
          key: 'config.pages.products.item.thumbnail.position',
          styleProperty: '--ui-product-card-content-text-align',
        },
        { // for placeholder
          key: 'config.pages.products.item.thumbnail.position',
          styleProperty: '--ui-product-card-content-align-items',
        },
        {
          key: 'config.pages.products.item.thumbnail.position',
          styleProperty: '--ui-product-card-price-list-justify-content',
        },
        {
          key: 'config.pages.products.item.thumbnail.roundedCorners',
          styleProperty: '--ui-product-card-image-border-radius',
        },
        {
          key: 'config.pages.products.item.price.position',
          styleProperty: '--ui-product-card-price-container-justify-content',
        },
        {
          key: 'config.pages.products.item.price.fontSize',
          styleProperty: '--ui-product-card-price-font-size',
        },
        {
          key: 'config.pages.products.item.enableDetails',
          styleProperty: '--ui-product-card-content-details-display',
        },
      ],
    }),
  },
  containerFilters: {
    minHeight: '9rem',
    margin: '1.2rem 0 1rem',
    display: 'none',
    flexDirection: 'column',
  },
  filterBox: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '2rem',
  },
  boxResetBtnStyle: {
    marginTop: '1.2rem',
    textAlign: 'left',
  },
  resetBtnStyle: {
    border: `1px solid ${theme.colors.bgMedium}`,
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '2.4rem',
    padding: '0.2rem 0.8rem 0.2rem 2.6rem',
    backgroundColor: theme.colors.bgLight,
    width: 'auto',
    minHeight: 0,
    '& img': {
      margin: 0,
    },
  },
  containerFiltersMobile: {
    marginTop: '2rem',
    display: 'flex',
    flexDirection: 'column',
  },
  filterBoxMobile: {
    display: 'flex',
    flexWrap: 'wrap',
    height: '3rem',
    '& div': {
      marginRight: 'min(6%, 2.2rem)',
    },
    '& img': {
      margin: 0,
      marginRight: '0.8rem',
    },
  },
  boxSortBy: (props) => ({
    position: 'relative',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: '0.1rem',
      right: '-0.8rem',
      display: props.isSelectBySort ? 'block' : 'none',
      height: '0.6rem',
      width: '0.6rem',
      backgroundColor: theme.colors.secondary,
      borderRadius: '50%',
    },
  }),
  boxFilter: (props) => ({
    position: 'relative',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: '0.1rem',
      right: '-0.8rem',
      display: props.isSelectFilters ? 'block' : 'none',
      height: '0.6rem',
      width: '0.6rem',
      backgroundColor: theme.colors.secondary,
      borderRadius: '50%',
    },
  }),
  filterByPageStyle: {
    display: 'flex',
    '& p': {
      marginLeft: '0.5rem',
      '& img': {
        transform: ' rotate(90deg)',
        marginLeft: '0.5rem',
      },
    },
    '& span': {
      '&:before': {
        display: 'none !important',
      },
    },
  },
  filterGroup: {
    display: 'flex',
    minHeight: '4rem',
    width: '70rem',
    '& > div': {
      marginRight: '2rem',
    },
  },
  filterGroupRight: {
    display: 'flex',
    minHeight: '4rem',
    '& > div': {
      marginLeft: '2rem',
    },
  },
  resultStyle: {
    fontSize: '1.6rem',
    lineHeight: 1.25,
    textAlign: 'left',
    color: theme.colors.primary,
    marginTop: '3rem',
  },
  noResultStyle: {
    padding: '0 1.5rem',
    margin: '0 auto',
    textAlign: 'center',
    width: '100%',
    maxWidth: theme.mediaQueries.mobile,
    '& p': {
      color: theme.colors.text,
      margin: '4rem 0',
      fontSize: '1.6rem',
      fontWeight: 600,
    },
  },
  dropdownFeatures: {
    width: '100%',
    maxWidth: '18rem',
  },
  dropdownSort: {
    width: '17rem',
    '& label': {
      top: '-3rem',
      textTransform: 'uppercase',
    },
  },
  dropdownView: {
    width: '11rem',
    '& label': {
      top: '-3rem',
      textTransform: 'uppercase',
    },
  },
  buttonContinue: {
    width: '100%',
  },
  emptyBreadCrumb: {
    height: 28,
  },
  pagination: {
    marginTop: 0,
    marginBottom: 0,
  },
  paginationTop: {
    display: 'var(--pages-products-pagination-top-display)',
  },
  paginationBottom: {
    display: 'var(--pages-products-pagination-bottom-display)',
  },
  [`@media (min-width: ${theme.mediaQueries.tablet}px)`]: {
    container: {
      width: '100%',
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      padding: 0,
    },
    containerFilters: {
      display: 'flex',
    },

    containerFiltersMobile: {
      display: 'none',
    },
    buttonContinue: {
      width: '37rem',
      margin: '0 auto',
    },
    breadcrumb: {
      paddingTop: '2rem',
      marginBottom: '15px',
    },
    // containerTitle: {
    //   marginTop: 0,
    // },
    emptyBreadCrumb: {
      height: 63,
    },
  },
  [`@media (min-width: ${theme.mediaQueries.desktop}px)`]: {
    container: {
      maxWidth: '1170px',
      width: '100%',
      margin: [[0, 'auto', 0]],
    },
    dropdownSort: {
      width: '24rem',
    },
  },
}))

export default useStyles
